import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Button,
  Divider,
  IconButton,
  Typography,
} from '@mui/material';
import EditRoundedIcon from '@mui/icons-material/EditRounded';
import { formatCurrency } from 'utils/formatter.js';
import StatusPill from 'components/StatusPill';

const TenantToolbar = ({ tenant,
  fnHandleEditTenantDialog,
  fnOnPaymentHandler,
  ...rest
}) => {
  return (
    <Box mt={3}>
      <Box
        display='flex'
        justifyContent='space-evenly'
      >
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {tenant.company}
          </Typography>
          <Typography
            align='center'
            variant='caption'         
          >
            {'COMPANY'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {tenant.tenantId}
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'ACCOUNT NUMBER'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {tenant.accountPlan}
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'PLAN'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {tenant.registrationDate}
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'REGISTRATION DATE'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {tenant.nextPaymentDate}
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'NEXT PAYMENT'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {tenant.lastPaidDate}
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'LAST PAYMENT DATE'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            {formatCurrency(tenant.paymentAmount)}
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'PAYMENT DUE'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'
            gutterBottom
            variant='subtitle2'
          >
            <StatusPill
              category={'account'}
              status={tenant.status}
              label={tenant.status}
              size='small'
            />    
          </Typography>
          <Typography
            align='center'
            variant='caption'            
          >
            {'STATUS'}
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Typography
            align='center'            
            gutterBottom
            variant='subtitle2'
            fontWeight={600}
          >
            <IconButton color='primary' aria-label='add an alarm' size='large'>
              <EditRoundedIcon onClick={fnHandleEditTenantDialog} />
            </IconButton>
          </Typography>
        </Box>
        <Divider orientation='vertical' flexItem />
        <Box>
          <Button
            variant='contained'
            color='primary'
            onClick={fnOnPaymentHandler}
          >
            {'Make Payment'}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

TenantToolbar.propTypes = {
  className: PropTypes.string
};

export default TenantToolbar;